/**
 * @fileoverview Workspace Pipeline Settings
 *
 * URL: /dashboard/pre-appointment-settings
 *
 * Firm-wide pipeline configuration (currently the conflict-check reminder
 * frequency). Lives under the workspace Pipeline section in the sidebar.
 * Admin/owner can edit; everyone else gets a read-only view.
 *
 * - Convex: preAppointment.settings.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { PreAppointmentSettingsManager } from "@/components/settings/pre-appointment/PreAppointmentSettingsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/pre-appointment-settings",
)({
  component: PreAppointmentSettingsPage,
});

function PreAppointmentSettingsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <PreAppointmentSettingsManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage pipeline settings.
        </div>
      )}
    </div>
  );
}
